exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-45c89908] .el-card__body{height:100%!important}", ""]);

// exports
